import React from 'react';
import '../styles/Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <ul className="nav-links">
        <li><a href="/">Home</a></li>
        <li>
          <a href={`https://wa.me/918949471009`}>Contact Us</a> 
        </li>
        <li><a href="https://t.me/mahadevwithdrall">Telegram</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;
